(function ($, Promise) {

    // Constructor
    function VICCShare() {
      // console.log("VICCShare: constructor()");

      this.tryAnotherAddress = new VICCTryAnotherAddress();
      this.breadcrumbs = new VICCVisualizeBreadcrumb();
      this.share = new VICCVisualizeShare();

      this.selectedDisaster = false;
      this.placename = false;

      this.breadcrumbs.setStatus(STEP_VISUALIZE)

    }

    VICCShare.prototype.attach = function (dom) {
      // console.log("VICCShare: attach()");

      this.tryAnotherAddress.attach();
      this.breadcrumbs.attach();
      this.share.attach();

      this.breadcrumbs.setStatus(STATUS_VISUALIZE);
      this.breadcrumbs.setStep(STEP_VISUALIZE);

      // Visualize (results) - pinch zoom
      var pinchOptions = {};
      this.pinchZoom = new PinchZoom.default($('#visualize-fullscreen-container .visualize-fullscreen-wrapper')[0], pinchOptions);

      // Init Triggers
      this.initTrigger();

      // Init Sliders
      app.components.visualize.initSwiper();

      // Select disaster
      this.selectDisaster(selectedDisaster);
    }

    VICCShare.prototype.selectDisaster = function (disaster) {
      // console.log("selectDisaster", selectedDisaster)

      this.selectedDisaster = disaster;
      this.share.selectedDisaster = disaster;
      selectedDisaster = disaster;

      // Change results slider slide
      if (app.components.visualize.swiperResults.length) {
        app.components.visualize.swiperResults[1].slideTo($(".visualize-result-slider .swiper-slide[class*=" + disaster + "]").index());
      }

      // Update result DOM
      $(".visualize-result-flood:not(.swiper-slide):not(.fullscreen)").toggleClass("hidden", (disaster != "flood"));
      $(".visualize-result-wildfire:not(.swiper-slide):not(.fullscreen)").toggleClass("hidden", (disaster != "wildfire"));
      $(".visualize-result-smog:not(.swiper-slide):not(.fullscreen)").toggleClass("hidden", (disaster != "smog"));

      this.breadcrumbs.setDisaster(disaster);
      $("#share").attr("data-disaster", disaster);
    }

    /*
     * Called by the Google Map API when it is ready to be used.
     */
    VICCShare.prototype.googleMapReady = function () {
      // console.log("VICCVisualize: googleMapReady()");
      this.tryAnotherAddress.googleMapReady();
    }

    /*
     * Init click events
     */
    VICCShare.prototype.initTrigger = function () {

      $(this.breadcrumbs).off("selectDisaster").on("selectDisaster", $.proxy(function (e, disaster) {
        this.selectDisaster(disaster);
      }, this));

      $(this.breadcrumbs).off("tryAnotherAddress").on("tryAnotherAddress", $.proxy(function (e) {
        this.tryAnotherAddress.showOverlay();
      }, this));

      $(this.tryAnotherAddress.overlayMap).off("selectAddress").on("selectAddress", $.proxy(function (e) {
        this.placename = this.tryAnotherAddress.overlayMap.placename;
      }, this));

      $(this.tryAnotherAddress).off("visualizationReady").on("visualizationReady", $.proxy(function (e, data) {
        this.share.currentHash = data.uniqueName;
        $("#breadcrumb-item-preview").css("background", "url(" + data.originalUrl + ") no-repeat center center");
        $("#breadcrumb-item-preview").css("background-size", "cover");

        $(".visualize-result-flood").empty().append("<img src='" + data.floodUrl + "' />");
        $(".visualize-result-wildfire").empty().append("<img src='" + data.wildfireUrl + "' />");
        $(".visualize-result-smog").empty().append("<img src='" + data.smogUrl + "' />");

        $(".hide-on-visualize").hide();

      }, this));

      // Results - toggle fullscreen result overlay
      $("#visualize-result .visualize-result-slider, #visualize-fullscreen-container .visualize-fullscreen-close").off("click").on("click", $.proxy(function () {
        app.components.visualize.visualizationResultToggleOverlay(this.pinchZoom);
      }, this));
    }

    VICCShare.prototype.dettach = function () {
      // console.log("VICCShare: dettach()");

      this.pinchZoom = false;
      for (var i = 0; i < app.components.visualize.swiperResults.length; i++) {
        app.components.visualize.swiperResults[i].destroy();
        if (i == app.components.visualize.swiperResults.length - 1) {
          app.components.visualize.swiperResults = [];
        }
      }

      this.selectedDisaster = false;
      this.placename = false;

      this.tryAnotherAddress.dettach();
      this.breadcrumbs.dettach();
      this.share.dettach();
    }

    // Expose VICCShare
    window.VICCShare = VICCShare;

  }
)
(jQuery, Promise);
